module.exports = __webpack_public_path__ + "img/file-text.0409d604.svg";